import {
  Tabs,
  Tab,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";

import useGlobalState from "../../Context";
import { BULK_APPOINTMENT_LISTING_COLUMNS } from "../../utils/constant";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import { useNotificationContext } from "../../common/NotificationContext";
import { Link as LinkRoute } from "react-router-dom";
import CachedIcon from "@mui/icons-material/Cached";
import { getBulkFileList } from "../../services/BulkAppointmentSevice";
import { useLoading } from "../../common/LoadingContext";
import { convertDateFromUTCString } from "../../utils/jsUtils";
import AddNew from "./AddNew";
import NoDataComponent from "../../common/RecordNotFound";

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3, px: 2 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const BulkAppointmentAddNewEntry = () => {
  const { showNotification } = useNotificationContext();
  const { setLoading } = useLoading();
  const [spin, setSpin] = useState(0);

  const [page, setPage] = useState(0);
  const [maxPage, setMaxPage] = useState(-1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [{ userDetails }] = useGlobalState();

  const [uploadedFilesRecord, setUploadedFilesRecord] = useState([]);

  const userParam = userDetails?.userParam;
  const vendorCode = userParam?.vendorCode;

  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (newValue === 0) {
      fetchBulkAppointmentList();
    }
  };

  const fetchBulkAppointmentList = async () => {
    try {
      setLoading(true);
      const requestBody = {
        vendorCode: parseInt(vendorCode, 10),
      };
      const bulkFileListResponse = await getBulkFileList(baseUrl, requestBody);
      if (bulkFileListResponse?.messageCode === 6) {
        setUploadedFilesRecord(bulkFileListResponse?.bulkParamList);
      } else {
        showNotification(
          "Error",
          bulkFileListResponse?.message ??
            "Failed To Fetch Bulk Uploaded File List"
        );
      }
    } catch (err) {
      showNotification(
        "Error",
        err?.message ?? "Failed To Fetch Bulk Uploaded File List"
      );
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchBulkAppointmentList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const refreshCanvas = () => {
    setSpin(true);
    setTimeout(() => {
      setSpin(false);
    }, 1000);
  };

  const handleChangeRowsPerPage = async (event) => {
    setPage(0);
    setMaxPage(0);
    setRowsPerPage(+event.target.value);
  };

  const handleChangePage = async (event, newPage) => {
    if (newPage > page && newPage > maxPage) {
      setMaxPage(newPage);

      setPage(newPage);
    } else {
      setPage(newPage);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Grid container>
        <Grid item xs={12}>
          <Paper elevation={3} variant="elevation" sx={{ width: "100%" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                scrollButtons="auto"
                aria-label="Bulk Appointment Tabs"
              >
                <Tab
                  iconPosition="start"
                  label={
                    <Typography
                      variant="button"
                      color="#4d6fa5"
                      sx={{ pt: 0.5 }}
                    >
                      BulkAppointment List
                    </Typography>
                  }
                  {...a11yProps(0)}
                />
                <Tab
                  iconPosition="start"
                  label={
                    <Typography
                      variant="button"
                      color="#4d6fa5"
                      sx={{ pt: 0.5 }}
                    >
                      Create New
                    </Typography>
                  }
                  {...a11yProps(1)}
                />
                <Grid container justifyContent={"flex-end"} mx={1}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginRight: "20px",
                    }}
                  >
                    {value === 0 && (
                      <CachedIcon
                        sx={{
                          ml: 3,
                          my: 1.5,
                          cursor: "pointer",
                          animation: spin ? "spin 2s linear infinite" : null,
                          "@keyframes spin": {
                            "0%": {
                              transform: "rotate(360deg)",
                            },
                            "100%": {
                              transform: "rotate(0deg)",
                            },
                          },
                        }}
                        spin={spin}
                        onClick={async () => {
                          try {
                            setLoading(true);
                            refreshCanvas();
                            setPage(0);
                            setMaxPage(0);
                            await fetchBulkAppointmentList();
                          } catch (err) {
                            showNotification(
                              "Error",
                              err?.message ??
                                "Failed To Fetch Bulk Appointment List"
                            );
                          } finally {
                            setLoading(false);
                          }
                        }}
                      />
                    )}
                  </Box>
                </Grid>
              </Tabs>
            </Box>

            <TabPanel value={value} index={0} sx={{ p: 0 }}>
              {uploadedFilesRecord && uploadedFilesRecord?.length > 0 ? (
                <>
                  <Divider />
                  <>
                    <Paper elevation={3} variant="elevation">
                      <TableContainer
                        sx={{ maxHeight: 720 }}
                        className="tableScroll"
                      >
                        <Table stickyHeader aria-label="sticky table">
                          <TableHead>
                            <TableRow key={"1"}>
                              {BULK_APPOINTMENT_LISTING_COLUMNS.map(
                                (column) => (
                                  <TableCell
                                    size="small"
                                    variant="head"
                                    key={column.id}
                                    className="tableHeader"
                                    sx={{ pt: 1.5, pb: 1.5, fontSize: "13px" }}
                                  >
                                    {column.label}
                                  </TableCell>
                                )
                              )}
                            </TableRow>
                          </TableHead>

                          <TableBody sx={{ mt: 2 }}>
                            {uploadedFilesRecord
                              .slice(
                                page * rowsPerPage,
                                page * rowsPerPage + rowsPerPage
                              )
                              .map((row, index) => {
                                return (
                                  <TableRow
                                    hover
                                    role="checkbox"
                                    tabIndex={-1}
                                    key={index}
                                  >
                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"bulkRequestId"}
                                    >
                                      {row["bulkRequestId"] ?? "-"}
                                    </TableCell>

                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"count"}
                                    >
                                      {row["count"] ?? "-"}
                                    </TableCell>
                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"statusContent"}
                                    >
                                      {row["statusContent"] ?? "-"}
                                    </TableCell>
                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"uploadedDate"}
                                    >
                                      {convertDateFromUTCString(
                                        row["uploadedDate"]
                                      ) ?? "-"}
                                    </TableCell>

                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"uploadedBy"}
                                    >
                                      {row["uploadedBy"] ?? "-"}
                                    </TableCell>
                                    <TableCell
                                      size="small"
                                      sx={{
                                        pt: 1.5,
                                        pb: 1.5,
                                        fontSize: "12px",
                                      }}
                                      key={"details"}
                                    >
                                      {row["status"] === 12 ? (
                                        <Box sx={{ display: "flex" }}>
                                          Details <ArrowForwardIcon />
                                        </Box>
                                      ) : (
                                        <LinkRoute
                                          to="/bulk-appointment-list"
                                          state={{
                                            bulkRequestId:
                                              row["bulkRequestId"] ?? "",
                                          }}
                                        >
                                          {" "}
                                          <Box sx={{ display: "flex" }}>
                                            Details <ArrowForwardIcon />
                                          </Box>
                                        </LinkRoute>
                                      )}
                                    </TableCell>
                                  </TableRow>
                                );
                              })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <TablePagination
                        rowsPerPageOptions={[10, 25, 50, 100]}
                        component="div"
                        count={uploadedFilesRecord.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                      />
                    </Paper>
                  </>
                </>
              ) : (
                <>
                  <NoDataComponent />
                </>
              )}
            </TabPanel>
            <TabPanel value={value} index={1}>
              <AddNew handleChange={handleChange} />
            </TabPanel>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
export default BulkAppointmentAddNewEntry;
